import _ from 'lodash';
import { Box, Flex, Dropdown, Icon, Text, Tooltip, Button } from '@vibe/core';
import { dropdownValue } from '@gorilla/ui/src/components/dropdownValue';
import { type PortalSettings, type ItemsPerPageFieldValue, type FieldValues } from '@gorilla/portal-shared/src/schemas';
import { Lines, LearnMore } from '@vibe/icons';
import { type ItemsPerPageFieldDescriptor, type SectionDescriptor } from '@gorilla/portal-shared/src/types';
import { useBoardSourceResolver } from '../../hooks/use-board-source-resolver';

const ITEMS_PER_PAGE_OPTIONS = [
  { label: '10', value: 10 },
  { label: '25', value: 25 },
  { label: '50', value: 50 },
  { label: '100', value: 100 },
];

type ItemsPerPageFieldProps = {
  value: ItemsPerPageFieldValue;
  fieldDescriptor: ItemsPerPageFieldDescriptor;
  portalSettings: PortalSettings;
  sectionDescriptor: SectionDescriptor;
  sectionFieldValues: FieldValues;
  clientBoardSubitemsBoardId: number | null;
  onChange: (value: ItemsPerPageFieldValue) => void;
  screenMode: 'small' | 'medium' | 'large';
  isOpen?: boolean;
};

export function ItemsPerPageField({
  portalSettings,
  sectionDescriptor,
  sectionFieldValues,
  clientBoardSubitemsBoardId,
  value,
  fieldDescriptor,
  onChange,
  screenMode,
  isOpen,
}: ItemsPerPageFieldProps) {
  const { board, isLoading, boardId } = useBoardSourceResolver({
    portalSettings,
    sectionDescriptor,
    clientBoardSubitemsBoardId,
    sectionFieldValues,
  });

  if (!boardId || isLoading || !board) {
    return null;
  }

  const selectedItemsPerPageOption = ITEMS_PER_PAGE_OPTIONS.find((option) => option.value === value) || ITEMS_PER_PAGE_OPTIONS[0];

  return (
    <Box
      border={true}
      borderColor="layoutBorderColor"
      style={{
        position: screenMode === 'medium' || screenMode === 'small' || !isOpen ? 'relative' : 'absolute',
        top: screenMode === 'medium' || screenMode === 'small' || !isOpen ? 'auto' : '165px',
        left: screenMode === 'medium' || screenMode === 'small' || !isOpen ? 'auto' : '57px',
        marginTop: screenMode === 'medium' || screenMode === 'small' || !isOpen ? '-1px' : '0px',
        width: screenMode === 'medium' || screenMode === 'small' || !isOpen ? '100%' : 'calc((50% - 57px))',
      }}
      className={`field-${fieldDescriptor.type}`}
    >
      <Box padding="medium">
        <Flex gap={32}>
          <Flex gap={8}>
            <div style={{ marginRight: '0px', fontSize: '12px', transform: 'translate3d(0,1px,0)' }}>
              <Icon icon={Lines} size={20} />
            </div>
            <Text type="text2" weight="medium" color="primary">
              Items per page
            </Text>
            {/* 
            <Tooltip
              content="Set the number of board items loaded and displayed per page for this board."
              position="right"
              showOnDialogEnter={false}
            >
              <Icon icon={LearnMore} iconSize={14} style={{ transform: 'translate3d(0,1px,0)' }} />
            </Tooltip>
            */}
          </Flex>
          <div
            style={{
              marginLeft: 'auto',
              width: '80px',
            }}
          >
            <Dropdown
              placeholder="Items per page"
              size="small"
              className="custom_dropdown"
              options={ITEMS_PER_PAGE_OPTIONS}
              value={dropdownValue(selectedItemsPerPageOption)}
              clearable={false}
              searchable={false}
              onChange={(selectedOption: any) => {
                onChange(selectedOption.value || fieldDescriptor.defaultValue || ITEMS_PER_PAGE_OPTIONS[0].value);
              }}
            />
          </div>
        </Flex>
      </Box>
    </Box>
  );
}
